<template>
<div>
    <a-modal
      :title="title"
      :visible="visible"
     :confirm-loading="confirmLoading"
     width="480px"
      @cancel="handleCancel"
    >
     <a-input-group compact style="margin-bottom:10px;">
      <a-select default-value="zname" @change="onSearchChange">
        <a-select-option value="zname">
          {{name_title}}
        </a-select-option>
        <a-select-option value="zcode">
          {{code_title}}
        </a-select-option>
      </a-select>
      <a-input-search style="width: 50%" default-value=""  @search="onSearch" />
    </a-input-group>

     <a-table
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:rowsType}"
      :columns="columns"
      :data-source="list"
      rowKey="uporganizationcode"
      :pagination="false"
    />
    <br />
    <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />
    
     <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
          确定
        </a-button>
      </template>
    </a-modal>
  </div>
  
</template>
<script>
const columns = [
    {
        title: '组织编码',
        dataIndex: 'uporganizationcode',
        align: 'center',
        width:80,
    }, {
        title: '组织名称',
        dataIndex: 'uporganizationname',
        align: 'center',
        width:80
    }
];

export default {
    data() {
        return {
            confirmLoading: false,
            columns:columns,
            selectedRowKeys: [], // Check here to configure the default column
            loading: false,
            rowsType:'radio',
            title:'',
            visible:false,
            list:[],
            searchKey:'zname',
            searchVal:'',
            usercode:'',
            name_title:'组织名称',
            code_title:'组织编码',
            updateorganizationcode:'',
            pagination:{
                total:0,
                pageSize:10,
                current:1,
            },
        };
    },
    computed: {
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
    },
    props:{
 
    },
    methods: {
        handlePageChange(params_page){
            console.log(params_page)
            this.onModalInit(this.updateorganizationcode,params_page)
        },
        onModalInit(upcode,current_page){
            this.organizationcode =upcode;
            let that = this;
            let c_params = {
                organizationcode:this.organizationcode,
                pageSize:that.pagination.pageSize,
                page:current_page
            }
            if(that.searchKey == 'zname'){
                c_params.updateorganizationname = that.searchVal
            }
            else{
                c_params.updateorganizationcode = that.searchVal
            }
            console.log(c_params);
            that.$store.dispatch({
                type: "orgcenter/queryUporg",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                let result = res.data.data;
                that.list = result.list;
                that.pagination.total = result.totalRecords;
                that.pagination.pageSize = result.pageSize;
                that.pagination.current = result.page;
                that.title = '选择所属组织';
            })
            that.visible = true;
        },


        onSearchChange(value){
            this.searchKey = value;
        },
        onSearch(value){
            this.searchVal = value;
            this.onModalInit(this.updateorganizationcode,1);
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handleOk(){
            let current_keys = this.selectedRowKeys;
            let result = this.list.filter(function(n){
                return current_keys.indexOf(n.uporganizationcode) != -1
            });
            this.$emit('onModalHide',result);
            this.visible = false;
        },
        handleCancel(e) {
            e.preventDefault()
            this.$emit('onModalHide');
            this.visible = false;
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    mounted() {

    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
